import { render, staticRenderFns } from "./EmailStatuses.vue?vue&type=template&id=1c997e12&scoped=true&"
import script from "./EmailStatuses.vue?vue&type=script&lang=js&"
export * from "./EmailStatuses.vue?vue&type=script&lang=js&"
import style0 from "./EmailStatuses.vue?vue&type=style&index=0&id=1c997e12&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c997e12",
  null
  
)

export default component.exports